import { render, staticRenderFns } from "./headerLogo.vue?vue&type=template&id=6484ecf0"
import script from "./headerLogo.vue?vue&type=script&lang=js"
export * from "./headerLogo.vue?vue&type=script&lang=js"
import style0 from "./headerLogo.vue?vue&type=style&index=0&id=6484ecf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports